import React, { useState, useEffect, useRef } from 'react';
import logo from '../assets/images/itc.png';
import App from '../App';
import {
   CModal,
   CModalHeader,
   CModalTitle,
   CModalBody,
   CButton,
   CSidebar,
   CSidebarHeader,
   CSidebarBrand,
   CSidebarNav,
   CNavTitle,
   CNavItem,
   CNavGroup,
   // CIcon,
   CSidebarToggler,
   CBadge,
} from '@coreui/react';

import CIcon from '@coreui/icons-react';
import {
   cilCloudDownload,
   cilLayers,
   cilPuzzle,
   cilSpeedometer,
} from '@coreui/icons';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from '../assets/images/itc.png';
import { clear, getObjectData } from '../services/Storage';
import jwt_decode from 'jwt-decode';
import swal from 'sweetalert';
import { Form, Button } from 'react-bootstrap';
import { storeObjectData } from '../services/Storage';
import authService from '../services/Auth';
import { toast } from 'react-toastify';
import { MutatingDots } from 'react-loader-spinner';
import { validate, validateProperty } from '../actions/utils';
import ProfileModalSchema from '../schema/ProfileModalschema';
import { useNavigate } from 'react-router-dom';

function Header() {
   const [visible, setVisible] = useState(false);
   const [pin, setPin] = useState(['', '', '', '']);
   const inputRefs = useRef([]);
   const [isLogin, setIsLogin] = useState(false);
   const [email, setEmail] = useState('');
   const [password, setPassword] = useState('');
   const [loginErrors, setLoginErrors] = useState({});
   const [isLoginLoading, setIsLoginLoading] = useState(false);

   const handleChange = (value, index) => {
      const newPin = [...pin];
      newPin[index] = value;
      setPin(newPin);

      // Move to the next input field
      if (value && index < 3) {
         inputRefs.current[index + 1].focus();
      }
   };
   const navigate = useNavigate();
   const logoutAlert = (e) => {
      e.preventDefault();
      try {
         swal({
            icon: 'warning',
            title: 'Are you sure?',
            text: 'Log Out from this session',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'LogOut',
            cancelButtonText: 'Cancel',
            buttons: true,
         }).then(async (value) => {
            if (value) {
               logoutUser();
            } else return;
         });
      } catch (error) {
         toast.error('Some Error Occured!');
      }
   };

   const logoutUser = async (e) => {
      await clear();
      navigate('/');
      window.location.reload();
   };

   const [user, setUser] = useState(null);

   useEffect(() => {
      getUserDetails();
   }, []);

   const getUserDetails = async () => {
      try {
         const tokenData = await getObjectData('auth');

         const userData = jwt_decode(tokenData.accessToken);
         if (userData) {
            setUser(userData);
         }
      } catch (error) {
         setUser(null);
      }
   };
   const [selectedPage, setSelectedPage] = useState(window.location.pathname);
   const [viewModal, setViewModal] = useState(false);
   const [profile, setProfile] = useState({});
   const [isLoading, setLoading] = useState(false);
   const [profileErrors, setProfileErrors] = useState({});
   const [error, setError] = useState({});

   useEffect(() => {
      getUserDetails();
      getProfile();
   }, []);

   const getProfile = async () => {
      try {
         const response = await authService.profile();
         if (response.status === 200 && response.data) {
            setProfile({
               name: response.data.name,
               email: response.data.email,
            });
         } else {
         }
      } catch (error) {
         console.error(error);
      }
   };

   const handleClick = async (e) => {
      setLoading(true);
      try {
         let payload = profile;
         const response = await authService.UpdateProfile(payload);
         if (response.status === 200) {
            setLoading(false);
            toast('Your profile updated successfully.', {
               position: 'top-right',
               autoClose: 1000,
            });
         } else if (response.response.status === 422) {
            toast.error('Email Already exists.');
            setLoading(false);
         } else {
            toast.error('Unable to update profile!');
            setLoading(false);
         }
      } catch (error) {
         toast.error('Something went wrong.');
         setLoading(false);
      }
   };

   const onChange = (e) => {
      setProfileErrors(null);
      setProfile({ ...profile, [e.target.name]: e.target.value });
      const errorMessage = validateProperty(
         { name: e.target.name, value: e.target.value },
         ProfileModalSchema,
      );
      if (errorMessage) {
         setError({ ...error, [e.target.name]: errorMessage });
      } else {
         setError({ ...error, [e.target.name]: '' });
      }
   };

   const getprofile = async () => {
      try {
         const response = await authService.profile();
         if (response.status === 200 && response.data) {
            await storeObjectData('user', response.data)
         }
      } catch (error) {
         console.log(error);
      }
   }

   const validateLoginForm = () => {
      const errors = {};
      
      if (!email.trim()) {
         errors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(email)) {
         errors.email = "Invalid email format";
      }
      
      if (!password) {
         errors.password = "Password is required";
      } else if (password.length < 6) {
         errors.password = "Password must be at least 6 characters";
      }
      
      setLoginErrors(errors);
      return Object.keys(errors).length === 0;
   };

   const handleLoginInputChange = (e, field) => {
      if (field === 'email') {
         setEmail(e.target.value);
         if (loginErrors.email) {
            setLoginErrors({...loginErrors, email: ''});
         }
      } else if (field === 'password') {
         setPassword(e.target.value);
         if (loginErrors.password) {
            setLoginErrors({...loginErrors, password: ''});
         }
      }
   };

   const handleLogin = async () => {
      if (!validateLoginForm()) {
         return;
      }
      
      setIsLoginLoading(true);
      try {
         const loginPayload = {
            email: email,
            password: password,
         };

         const response = await authService.login(loginPayload);
         if (response.status === 201) {
            await storeObjectData('auth', response.data);
            getprofile();
            setIsLogin(true);
            navigate('/user/myBooking');
            // Close modal and reset form
            setVisible(false);
            setEmail('');
            setPassword('');
            setLoginErrors({});
         } else {
            setLoginErrors({general: "Invalid email or password"});
         }
      } catch (error) {
         console.error("Login error:", error);
         setLoginErrors({
            general: error.response?.data?.message || "Login failed. Please try again."
         });
      } finally {
         setIsLoginLoading(false);
      }
   };

   useEffect(
      () => setSelectedPage(window.location.pathname),
      [window.location],
   );

   return (
      <>
         {/* // -------------Login Modal For Customer/User----------------- // */}

         <CModal
            alignment="center"
            visible={visible}
            onClose={() => {
               setVisible(false);
               setIsLogin(false);
               setEmail('');
               setPassword('');
               setLoginErrors({});
            }}
         >
            <div className="">
               <div className="">
                  <div className="p-12">
                     <div className="flex justify-center">
                        <img src={logo} className="w-44" />
                     </div>

                     <h1 className="text-xl font-bold text-center font-quicksand">
                        SignIn to Inspect This Car
                     </h1>

                     {loginErrors.general && (
                        <div className="mt-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
                           {loginErrors.general}
                        </div>
                     )}

                     <div className="mt-8">
                        <label className="!text-black font-quicksand font-medium">
                           Email Address *
                        </label>
                        <br />
                        <input
                           className={`border-2 mt-2 rounded-md w-full p-2 ${loginErrors.email ? 'border-red-500' : ''}`}
                           type="email"
                           value={email}
                           onChange={(e) => handleLoginInputChange(e, 'email')}
                        />
                        {loginErrors.email && (
                           <div className="text-red-500 text-sm mt-1">{loginErrors.email}</div>
                        )}
                     </div>

                     <div className="mt-4">
                        <label className="!text-black font-quicksand font-medium">
                           Password *
                        </label>
                        <br />
                        <input
                           className={`border-2 mt-2 rounded-md w-full p-2 ${loginErrors.password ? 'border-red-500' : ''}`}
                           type="password"
                           value={password}
                           onChange={(e) => handleLoginInputChange(e, 'password')}
                           onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                 handleLogin();
                              }
                           }}
                        />
                        {loginErrors.password && (
                           <div className="text-red-500 text-sm mt-1">{loginErrors.password}</div>
                        )}
                     </div>

                     <div className="flex justify-end mt-6">
                        <CButton
                           color="primary"
                           className={`w-[40%] text-white shadow-xl ${isLoginLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                           onClick={handleLogin}
                           disabled={isLoginLoading}
                        >
                           {isLoginLoading ? (
                              <span className="flex items-center justify-center">
                                 <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></span>
                                 Logging in...
                              </span>
                           ) : (
                              'Login'
                           )}
                        </CButton>
                     </div>
                  </div>
               </div>
            </div>
         </CModal>

         {/* //-------------End Modal-------------------------------------// */}
         <Navbar bg="white" expand="lg" className="p-0">
            <Container fluid="sm">
               <Navbar.Brand href="/" className="p-0">
                  <img
                     className="w-full h-20 max-w-md:max-h-24"
                     src={Logo}
                     alt="Logo"
                  />
               </Navbar.Brand>
               <Navbar.Toggle aria-controls="navbarScroll" />
               <Navbar.Collapse id="navbarScroll">
                  <Nav
                     className="ml-auto flex flex-col lg:flex-row"
                     navbarScroll
                  >
                     {!user ? (
                        <>
                           <Nav.Link
                              href="/blog"
                              className="font-semibold text-blue-500 text-base font-quicksand my-2 lg:my-0 lg:ml-4 text-center"
                           >
                              Blog
                           </Nav.Link>
                           <Nav.Link
                              href="/register"
                              className="font-semibold text-blue-600 text-base font-quicksand my-2 lg:my-0 lg:ml-4"
                           >
                              Sign Up
                           </Nav.Link>
                           <Nav.Link
                              onClick={() => setVisible(!visible)}
                              className="font-semibold text-blue-600 text-base font-quicksand my-2 lg:my-0 lg:ml-4"
                           >
                              Login
                           </Nav.Link>
                        </>
                     ) : (
                        <>
                           <Nav.Link
                              href="/user/blog"
                              className="font-semibold text-black text-base font-quicksand my-2 lg:my-0 lg:ml-4 hover:text-blue-600"
                           >
                              Blog
                           </Nav.Link>
                           <Nav.Link
                              onClick={() => setViewModal(true)}
                              className="font-semibold text-black text-base font-quicksand my-2 lg:my-0 lg:ml-4 hover:text-blue-600"
                              style={{
                                 textDecoration:
                                    selectedPage === '' ? 'underline' : 'none',
                              }}
                           >
                              Profile
                           </Nav.Link>
                           <Nav.Link
                              href="/user/mybooking"
                              className="font-semibold text-black text-base font-quicksand my-2 lg:my-0 lg:ml-4 hover:text-blue-600"
                           >
                              My Booking
                           </Nav.Link>
                           <Nav.Link
                              onClick={logoutAlert}
                              className="font-semibold text-black text-base font-quicksand my-2 lg:my-0 lg:ml-4 hover:text-blue-600"
                           >
                              Logout
                           </Nav.Link>
                        </>
                     )}
                  </Nav>
               </Navbar.Collapse>
               <CModal
                  size="md"
                  visible={viewModal}
                  onClose={() => setViewModal(false)}
                  className="p-4"
               >
                  <CModalHeader onClose={() => setViewModal(false)}>
                     <CModalTitle className="font-semibold text-blue-900">
                        Profile
                     </CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                     <Form>
                        <Form.Group className="mb-3">
                           <Form.Label className="font-medium text-gray-700">
                              Name
                           </Form.Label>
                           <Form.Control
                              className="rounded-md h-10 mb-2"
                              type="text"
                              placeholder="Name"
                              name="name"
                              value={profile.name}
                              onChange={onChange}
                           />
                           {error.name && (
                              <div className="text-red-500 mb-3 text-xs font-normal">
                                 {error.name}
                              </div>
                           )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                           <Form.Label className="font-medium text-gray-700">
                              Email
                           </Form.Label>
                           <Form.Control
                              className="rounded-md h-10 mb-2"
                              type="email"
                              placeholder="Email"
                              name="email"
                              value={profile.email}
                              onChange={onChange}
                           />
                           {error.email && (
                              <div className="text-red-500 mb-3 text-xs font-normal">
                                 {error.email}
                              </div>
                           )}
                        </Form.Group>

                        {isLoading ? (
                           <div className="flex justify-center">
                              <MutatingDots
                                 height="80"
                                 width="80"
                                 radius="9"
                                 color="black"
                                 ariaLabel="three-dots-loading"
                              />
                           </div>
                        ) : (
                           <div className="flex justify-end">
                              <Button
                                 onClick={handleClick}
                                 className="bg-blue-600 w-36 rounded-md border-none mb-4 font-medium h-10 text-white"
                              >
                                 Update Profile
                              </Button>
                           </div>
                        )}
                     </Form>
                  </CModalBody>
               </CModal>
            </Container>
         </Navbar>
      </>
   );
}

export default Header;
